// extracted by mini-css-extract-plugin
module.exports = {"container":"CardListB_container__2EHBX","header":"CardListB_header__37Tjq","title":"CardListB_title__1F5AW","item":"CardListB_item__3I5L2"};